// Flatpickr 4.6.13 loader for Shopify theme
// https://cdn.jsdelivr.net/npm/flatpickr
(function(){
  if (window.flatpickr) return;
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/flatpickr';
  script.onload = function(){ document.dispatchEvent(new Event('flatpickr:loaded')); };
  document.head.appendChild(script);
})();
